/**
 * Centralized business / brand configuration for E & J Painting.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "E & J Painting",
  shortName: "E & J Painting",
  legalName: "E & J Painting",
  owner: "Edrick Alamillo",
  tagline: "Professional Interior & Exterior Painting in Middle Tennessee",
  description:
    "Professional painting contractor based in Murfreesboro, TN serving Nashville, Franklin, Brentwood, Smyrna and the surrounding Middle Tennessee area. Interior, exterior, residential, commercial, and drywall painting — free estimates, Monday through Friday.",

  domain: "ej-painting.com",
  url: "https://ej-painting.com",

  phone: "(615) 930-6254",
  phoneHref: "tel:+16159306254",

  email: "eyjpainting2@gmail.com",
  emailHref: "mailto:eyjpainting2@gmail.com",

  address: {
    street: "1205 Merritt Hill Trail",
    city: "Smyrna",
    state: "TN",
    postalCode: "37167",
    region: "Rutherford County",
    serviceRadius: "50 miles",
    full: "1205 Merritt Hill Trail, Smyrna, TN 37167",
  },

  hours: {
    summary: "Mon – Fri · 8 AM – 5 PM",
    days: "Monday – Friday",
    time: "8:00 AM – 5:00 PM",
  },

  /** PNG original — kept for Open Graph, the favicon, and structured data,
   *  where WebP support is not universal across scrapers. */
  logo: "/ej-painting-logo.png",
  /** Resized WebP for on-page rendering: same mark, 86.7 KB -> 18.3 KB, and
   *  still 3x the largest size it is ever displayed at. */
  logoImage: "/ej-painting-logo.webp",
  ogImage: "/ej-painting-logo.png",
  favicon: "/ej-painting-logo.png",

  social: {
    instagram: null,
    facebook: null,
    tiktok: null,
    yelp: null,
  },

  discount: {
    label: "15% Off — First 3 Calls of the Month",
    short: "15% Off First 3 Calls",
    description:
      "The first three customers to book each month receive 15% off their painting project. Returning customers and referrals qualify too — just mention it when you call.",
  },

  widgets: {
    chatWidgetId: "6a76105746dfe9c546b6f807",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/q02O5e04eqWCrmxo4TQJ?widgetId=6a7c9ceb21bad23e79eda2a9",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/zznC3HCYJPnstBnlXlpc",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "zznC3HCYJPnstBnlXlpc",
    formHeight: "694",
    formName: "Website Form",
  },

  serviceAreas: [
    "Murfreesboro, TN",
    "Nashville, TN",
    "Franklin, TN",
    "Brentwood, TN",
    "Smyrna, TN",
    "La Vergne, TN",
    "Nolensville, TN",
    "Mount Juliet, TN",
    "Lebanon, TN",
    "Hendersonville, TN",
    "Gallatin, TN",
    "Spring Hill, TN",
    "Columbia, TN",
    "Clarksville, TN",
    "Dickson, TN",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
